import React from "react";
import { NavLink } from "react-router-dom";

import AuthContext from "../../../../AuthContext";
import mtzApis from "../../../../services";
import "./style.css";
const { companyService } = mtzApis;

export default function CompanyGroupDisplaySummary({ companyId, profileName }) {
  let [company, setCompany] = React.useState(null);
  let [companyGroups, setCompanyGroups] = React.useState(null);
  const me = React.useContext(AuthContext);

  React.useEffect(() => {
    (async () => {
      // get comp
      let company;
      if (companyId) company = await companyService.getCompanyById(companyId);
      if (profileName) {
        const companies = await companyService.getCompanies(
          new URLSearchParams(`profileName=${profileName}`)
        );
        if (companies) company = companies[0];
      }
      if (!company) return;

      // get comp's group members
      let companyGroupMembers = await companyService.getCompanyGroupMembers(
        new URLSearchParams(`userIds=${company.ownerId}`)
      );
      let map = {};
      companyGroupMembers.forEach(
        (companyGroupMember) =>
          (map[companyGroupMember.companyGroupId] = companyGroupMember)
      );

      // get comp's groups
      let companyGroups = await companyService.getCompanyGroups(
        new URLSearchParams(`companyGroupIds=${companyGroupMembers.map(m => m.companyGroupId)}&limit=5`)
      );
      companyGroups.forEach(
        (companyGroup) =>
          (companyGroup.companyGroupMember = map[companyGroup.id])
      );
      setCompanyGroups(companyGroups);
      setCompany(company);
    })();
  }, [companyId, profileName]);

  const updateHideOnCompanyProfile = async (companyGroup, checked) => {
    const updatedCompanyGroupMember = await companyService.updateCompanyGroupMemberById(companyGroup.companyGroupMember.id, {
      asHiddenOnCompanyProfile: checked ? true : false
    });

    if (updatedCompanyGroupMember) {
      let updatedCompanyGroups = companyGroups.map((cg) => {
        if (cg.companyGroupMember.id === updatedCompanyGroupMember.id)
          cg.companyGroupMember = updatedCompanyGroupMember;

        return cg;
      });
      setCompanyGroups(updatedCompanyGroups);
    }
  }

  return (
    <div className="mtz-card">
      <h5 className="mtz-h5">
        Associated Groups
      </h5>

      <div>
        {companyGroups === null && <div>Loading...</div>}

        {companyGroups && companyGroups.length === 0 && <div>No groups found</div>}

        {
          companyGroups && company && companyGroups.length > 0 &&
          <>
            <ul className="list-group">
              {
                companyGroups.length > 0 && companyGroups.map((companyGroup) => (
                  (me.userId === company.ownerId ||
                    companyGroup.companyGroupMember.asHiddenOnCompanyProfile === false) &&
                  <li key={companyGroup.id} className="list-group-item">
                    <div className="d-flex align-items-center mtz-gap-8">
                      <div style={{ width: '40px', height: '40px', marginRight: '10px' }}>
                        {
                          companyGroup.logoUrl ?
                            <img src={companyGroup.logoUrl && companyService.getBackendHost() + companyGroup.logoUrl}
                              alt={companyGroup.name} style={{ width: '100%', height: '100%', borderRadius: '50%' }} /> :
                            <i className="fa fa-users" style={{ fontSize: '25px', color: 'gray' }}></i>
                        }
                      </div>
                      <NavLink key={companyGroup.id} className="" to={`/groups/${companyGroup.profileName}`} target="_blank">
                        {companyGroup.name}&nbsp;
                        {/* <small className={company.ownerId === companyGroup.ownerId ? "text-danger" : "text-muted"}> */}
                        {/* {companyGroup.ownerId === company.ownerId ? "(admin)" : ""} */}
                        {/* </small> */}
                      </NavLink>

                      <span className="flex-fill"></span>

                      {
                        company && me && company.ownerId === me.userId &&
                        <div className="form-check">
                          <label className="form-check-label">
                            <input type="checkbox" className="form-check-input"
                              checked={companyGroup.companyGroupMember.asHiddenOnCompanyProfile == true}
                              onChange={e => updateHideOnCompanyProfile(companyGroup, e.target.checked)} /> Hide this group? <span
                                className={companyGroup.companyGroupMember.asHiddenOnCompanyProfile == true ? "text-danger" : "text-muted"}>
                              ({companyGroup.companyGroupMember.asHiddenOnCompanyProfile == true ? "Yes" : "No"})
                            </span>
                          </label>
                        </div>
                      }
                    </div>
                  </li>
                ))
              }
            </ul>

            <br />

            <div className="text-right">
              <NavLink to={`/profile/${company.profileName}/groups`} className="mtz-link">View all groups</NavLink>
            </div>
          </>
        }
      </div>
    </div >
  );
}

